export default "__VITE_ASSET__bdDbQjJD__"